<template lang="html">
  <div class="card-wrapper">
    <div class="data">
      <span class="key">Redni Br.</span>
      <span class="value">{{ num }}</span>
    </div>
    <div class="data" v-for="(col, index) in columns" :key="index">
      <span class="key">{{ col.label }}</span>
      <div class="value">
        <a
          v-if="col.key === 'wrk_name' && rank.work_file"
          :href="generateDownloadLink(rank)"
        >
          {{ rank[col.key] }}
        </a>
        <a
          v-else-if="col.key === 'wrk_name' && rank.wrk_work"
          :href="generateLink(rank)"
          target="_blank"
        >
          {{ rank[col.key] }}
        </a>
        <a
          v-else-if="
            col.key === 'wrk_sponsor_name' &&
              rank.wrk_sponsor_name &&
              rank.wrk_sponsor_link
          "
          :href="generateSponsorLink(rank)"
          target="_blank"
        >
          {{ rank[col.key] }}
        </a>
        <a
          v-else-if="col.key === 'sch_name' && rank.sch_website"
          :href="generateSchoolLink(rank)"
          target="_blank"
        >
          {{ rank[col.key] }}
        </a>
        <span v-else>{{ rank[col.key] }}</span>
      </div>
    </div>
    <div v-if="!archived && isWoting" class="btn-wrapper">
      <div @click="$emit('checkVoter')" class="btn">
        <img
          src="@/assets/icons/check.png"
          alt=""
          style="margin-right: 10px;"
        />
        GLASAJ
      </div>
    </div>
  </div>
</template>

<script>
import { baseURL } from '@/api'
export default {
  name: 'small-rank-list',
  props: ['columns', 'rank', 'num', 'archived', 'competition'],
  emits: ['checkVoter'],
  methods: {
    generateDownloadLink (work) {
      return baseURL + work.work_file
    },
    generateLink (work) {
      return work.wrk_work
    },
    generateSponsorLink (work) {
      return work.wrk_sponsor_link
    },
    generateSchoolLink (work) {
      return work.sch_website
    }
  },
  computed: {
    isWoting () {
      if (this.competition) {
        let now = new Date()
        let start = new Date(this.$moment.utc(this.competition.cmp_from_vote))
        let end = new Date(this.$moment.utc(this.competition.cmp_to_vote))
        if (now > start && now < end) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-wrapper {
  background: #f2f2f2;
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-width: 200px;
  width: 400px;
  max-width: 100%;
  margin-bottom: 20px;

  .data {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .key {
      text-align: left;
      max-width: 50%;
    }
    .value {
      text-align: right;
      margin-left: 20px;
    }
  }
  .btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
